import { render } from "./StrokedCartIcon.vue?vue&type=template&id=0226f696"
import script from "./StrokedCartIcon.vue?vue&type=script&lang=js"
export * from "./StrokedCartIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__